<template>
  <v-dialog v-model="dialog" max-width="500px">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined color="primary" text small>
        Light Setting
      </v-btn>
    </template>

    <Loading :loading="isLoading" />

    <v-card>
      <CardToolbar title="Light Settings" />
      <!-- <v-card-title>
        <h2 class="text-h6 font-weight-bold">Light Settings</h2>
      </v-card-title> -->

      <v-container grid-list-lg>
        <v-row dense>
          <!-- Enable/Disable Light -->
          <v-col cols="12">
            <v-btn
              :color="Lightenabled ? 'error' : 'success'"
              block
              @click="Lightenabled ? disableLight() : enableLight()"
            >
              {{ Lightenabled ? "Disable Light" : "Enable Light" }}
            </v-btn>
          </v-col>

          <!-- Show/Hide Percentage -->
          <v-col cols="12">
            <v-btn color="primary" block @click="updatePercentage">
              {{
                lightPercentageHidden ? "Show Percentage" : "Hide Percentage"
              }}
            </v-btn>
          </v-col>

          <!-- Show/Hide Amount -->
          <v-col cols="12">
            <v-btn color="primary" block @click="updateAmount">
              {{ lightAmountHidden ? "Show Amount" : "Hide Amount" }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import expenseService from "../service.js";
import Loading from "../../../../../components/LoadingDialog";

export default {
  name: "location-expense-lightSetting",
  props: {
    locationIntegration: { type: Object, required: true },
    LocationId: { type: [Number, String], required: true },
    location: { type: Object, default: () => ({}) },
  },
  components: { Loading },
  data() {
    return {
      isLoading: false,
      dialog: false,
    };
  },
  computed: {
    Lightenabled() {
      return !!this.locationIntegration?.IntegrationSettings?.metadata
        ?.lightSettings?.enable;
    },
    lightPercentageHidden() {
      return !!this.locationIntegration?.IntegrationSettings?.metadata
        ?.lightSettings?.hidePercentage;
    },
    lightAmountHidden() {
      return !!this.locationIntegration?.IntegrationSettings?.metadata
        ?.lightSettings?.hideAmount;
    },
  },
  methods: {
    async enableLightSetting() {
      this.isLoading = true;
      try {
        await expenseService.enableLightSetting({
          LocationId: this.LocationId,
        });
      } catch (error) {
        this.$toasted.error(error.data?.message || error.message, {
          position: "top-right",
          icon: "error",
          duration: 4000,
        });
      } finally {
        this.isLoading = false;
      }
    },
    async disableLightSetting() {
      try {
        await expenseService.disableLightSetting({
          LocationId: this.LocationId,
        });
      } catch (error) {
        this.$toasted.error(error.data?.message || error.message, {
          position: "top-right",
          icon: "error",
          duration: 4000,
        });
      }
    },
    async updateLightSetting(lightSettings) {
      try {
        await expenseService.updateLightSetting({
          LocationId: this.LocationId,
          lightSettings,
        });
      } catch (error) {
        this.$toasted.error(error.data?.message || error.message, {
          position: "top-right",
          icon: "error",
          duration: 4000,
        });
      }
    },
    async enableLight() {
      await this.enableLightSetting();
      this.locationIntegration.IntegrationSettings.metadata.lightSettings.enable = true;
    },
    async disableLight() {
      await this.disableLightSetting();
      this.locationIntegration.IntegrationSettings.metadata.lightSettings.enable = false;
    },
    updatePercentage() {
      const settings =
        this.locationIntegration.IntegrationSettings.metadata.lightSettings;
      settings.hidePercentage = !settings.hidePercentage;
      this.updateLightSetting(settings);
    },
    updateAmount() {
      const settings =
        this.locationIntegration.IntegrationSettings.metadata.lightSettings;
      settings.hideAmount = !settings.hideAmount;
      this.updateLightSetting(settings);
    },
  },
};
</script>
